import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Invoice } from "@common/types/invoice";
import { Button } from "@design-system/Button/Button";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import viewTableStyles from "@design-system/ViewTable/ViewTable.module.scss";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import { InvoicesViewCallbacks } from "../types";

export const SelectCell = memo(
    ({ row, table }: CellContext<ViewTableFeatures, Invoice, unknown>) => {
        const invoice = row.original;
        const { callbacks } = useViewTableMeta<InvoicesViewCallbacks, unknown>(
            table,
        );

        return (
            <ViewTableCell captureClicks>
                <Button
                    variant="primary"
                    size="sm"
                    className={viewTableStyles.showOnHover}
                    onClick={(event) => {
                        event.stopPropagation();
                        callbacks?.onSelectInvoice?.(invoice);
                    }}
                >
                    Select
                </Button>
            </ViewTableCell>
        );
    },
);
